import {Box, Clickable, HStack, VStack} from 'platform/foundation';
import styled from 'styled-components';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface ResultRowShellProps extends TestIdProps {
  avatar: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  onSelect: () => void;
}

export function ResultRowShell(props: ResultRowShellProps) {
  return (
    <Clickable
      onClick={props.onSelect}
      role="button"
      data-testid={suffixTestId('selectCustomer', props)}
    >
      <HoverableRow>
        <Box
          paddingVertical={3}
          paddingHorizontal={4}
          borderBottom="1px solid"
          borderColor="palettes.neutral.40.100"
          backgroundColor="palettes.white.10.100"
        >
          <HStack align="center" spacing={3}>
            {props.avatar}
            <Box flex={1} minWidth={0}>
              <VStack spacing={1}>{props.children}</VStack>
            </Box>
            {props.aside}
          </HStack>
        </Box>
      </HoverableRow>
    </Clickable>
  );
}

const HoverableRow = styled.div`
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease-in-out;
  &:hover {
    background-color: ${({theme}) => theme.colors.palettes.neutral[20][100]};
  }
`;
